export const FZI_ROCK_TYPES = [
  { label: 'RT0', fzi: 0.35 },
  { label: 'RT1', fzi: 0.85 },
  { label: 'RT2', fzi: 1.55 },
  { label: 'RT3', fzi: 2.07 },
  { label: 'RT4', fzi: 2.75 },
  { label: 'RT5', fzi: 4.00 },
  { label: 'RT6', fzi: 10.40 },
];

export const PORO_PERCENT_VALUES = [
  1.5, 3.5, 6.0, 8.5, 11.0, 13.5, 16.0, 18.5, 21.0, 23.5,
  26.0, 28.5, 31.0, 33.5, 36.0, 38.5, 41.0, 43.5, 46.0,
];

/**
 * Compute K (mD) for a given FZI and porosity percentage.
 * Derived from: RQI = 0.0314 * sqrt(K/φ), FZI = RQI / PHIZ
 * => K = φ * (FZI * PHIZ / 0.0314)^2  where PHIZ = φ/(1−φ)
 */
export const computeK = (fzi: number, poroPercent: number): number => {
  const phi = poroPercent / 100;
  if (phi <= 0 || phi >= 1) return 0;
  const phiz = phi / (1 - phi);
  return phi * Math.pow((fzi * phiz) / 0.0314, 2);
};

export const generateRockTypeCurve = (fzi: number, poroPercents: number[]): [number, number][] =>
  poroPercents
    .map((p): [number, number] => [p, computeK(fzi, p)])
    .filter(([, k]) => k > 0 && Number.isFinite(k));
